import { T } from '@tribeplatform/react-components/i18n'

import { FederatedSearchCard } from '../FederatedSearchCard.js'

export function FederatedSearchRouter() {
  return <FederatedSearchCard />
}

export function FederatedSearchBreadCrumb() {
  return <T id="Search.FederatedSearch" defaultMessage="Federated Search" />
}
